module.exports = __webpack_public_path__ + "static/img/empty_preview.d46e0d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty_preview.png
// module id = 9kXI
// module chunks = 1